// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
module.exports = {
    "new": $foreign["new"],
    add: $foreign.add,
    drain: $foreign.drain
};
//# sourceMappingURL=index.js.map
